import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const FooterBottom = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid #ccc',
        padding: '8px',
        backgroundColor: '#ffffff',
        position: 'relative',
        zIndex: 1000,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption">
          © {new Date().getFullYear()} Home Buying Network. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default FooterBottom;